import {
    CHECK_TERMS_CONDITIONS,
    UNCHECK_TERMS_CONDITIONS
  } from '../../GlobalStateContainer'


  export function termsAndConditions(state = false, action) {
    switch(action.type) {
        case CHECK_TERMS_CONDITIONS:
        return true;
        case UNCHECK_TERMS_CONDITIONS:
        return false;
    }
    return state;
}